type CompactTableDateProps = {
  value?: string | null
  includeTime?: boolean
  includeYear?: boolean
  includeWeekday?: boolean
}

export function CompactTableDate({
  value,
  includeTime = true,
  includeYear = true,
  includeWeekday = false,
}: CompactTableDateProps) {
  if (!value) {
    return <span className="text-muted-foreground">-</span>
  }

  const parsed = new Date(value)
  if (!Number.isFinite(parsed.getTime())) {
    return <span className="text-muted-foreground">-</span>
  }

  const dateLabel = parsed.toLocaleDateString(undefined, {
    weekday: includeWeekday ? 'short' : undefined,
    day: '2-digit',
    month: 'short',
    year: includeYear ? 'numeric' : undefined,
  })

  if (!includeTime) {
    return <span className="text-xs font-medium text-foreground">{dateLabel}</span>
  }

  return (
    <span className="flex flex-col gap-0.5">
      <span className="text-xs font-medium text-foreground">{dateLabel}</span>
      <span className="text-xs text-muted-foreground">
        {parsed.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hour12: false })}
      </span>
    </span>
  )
}

/** Matches bookings/orders table wrapper typography. */
export const commerceTableClassName = 'text-sm leading-5'
